import * as z from "zod";
import { userFacingError } from "../authorization";
import { assertAccess } from "../rbac/access";
import { mutator } from "./mutator";

// Revoke an active OAuth grant. Revocation is instant: the resource server
// re-checks revokedAt on every request. Two grant kinds, two authorizations,
// so both are checked in the body rather than a single declared permission: a
// grant acting as a service account is revoked by a manager of that account
// (service_account:manage); a user-acting grant is the consenting user's own
// and revoked by them (a third party they connected).
export const revokeOAuthGrant = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {
    grant: { kind: "oauthGrant", from: "id" },
  },
  permissions: {
    none: "ownership-based: the consenting user or a service-account manager, branched in fn",
  },
  fn: async ({ tx, ctx, args: { grant } }) => {
    if (grant.serviceAccountId) {
      // principal-exempt: not exposed on any public API route — reachable only
      // via the browser /zero/mutate path, so ctx.principal is never a service
      // account here.
      await assertAccess({
        tx,
        userId: ctx.userId,
        scopeId: grant.serviceAccountId,
        tenantId: ctx.tenantId,
        permission: "service_account:manage",
      });
    } else if (grant.userId !== ctx.userId) {
      throw userFacingError("OAuth grant not found");
    }
    await tx.mutate.oauthGrant.update({
      id: grant.id,
      revokedAt: Date.now(),
    });
  },
});
